// extracted by mini-css-extract-plugin
module.exports = {"page":"CES2025_page__pxbR4"};